import { BaseModel } from '../../../../../../core/_base/crud';

    export class DeNghiNhapKho extends BaseModel {

        static category_path = "DNNK";
        static DEFAULT_NUMBER_VALUE = "0,00";
        static DEFAULT_NUMBER_VALUE_NUMBER = "0.00";
        static DEFAULT_LOAIPHIEU = 0;
        static DEFAULT_NPSLPTTHV_KETQUASANXUAT = "NPSLPTTHV_KETQUASANXUAT";
        static DEFAULT_LYDO = 'DNNK';
        static DEFAULT_LYDOKHAC = '9999';
        static DEFAULT_LYDOHTNCC = 'HTNCC';

        static optionsTinhTrang = [
            {
                id: 1,
                name: 'Đang soạn thảo',
                value: 'DNNK_DANGSOANTHAO',
                defaultChecked: true,
            },
            {
                id: 2,
                name: 'Đang thực hiện',
                value: 'DNNK_CHOXULY',
                defaultChecked: true,
            },
            {
                id: 3,
                name: 'Hoàn tất',
                value: 'DNNK_HOANTAT',
                defaultChecked: true,
            },
            {
                id: 4,
                name: 'Đã hủy',
                value: 'DNNK_DAHUY',
            },
            {
                id: 5,
                name: 'Chờ duyệt',
                value: 'DNNK_CHODUYET',
                defaultChecked: true,
            },
            {
                id: 6,
                name: 'Không duyệt',
                value: 'DNNK_KHONGDUYET',
                defaultChecked: false,
            },
            {
                id: 7,
                name: 'Đã đóng',
                value: 'DNNK_DADONG',
                defaultChecked: false,
            },
        ];
        static optionsLoaiPhieu = [
            {
                value: 'NHAPHANGSANXUAT',
                name: 'Nhập hàng sản xuất',
                dfLenhSanXuatNK : true
            },
            {
                value: 'NHAPDUNPLBBBTP',
                name: 'Nhập thừa từ SX',
                dfLenhSanXuatNTK : true
            },
            {
                value: 'NHAPDUNCCGIAO',
                name: 'Nhập dư hàng NCC giao',
            },
            {
                value: 'NHAPHANGCHUYENKHO',
                name: 'Nhập hàng chuyển kho',
            },
            {
                value: 'NHAPHANGSANXUATCANPL',
                name: 'Nhập hàng sản xuất phòng cân'
            },
            {
                value: 'HANGTRAVETUKHACHHANG',
                name: 'Hàng trả về từ khách hàng'
            }
        ];

        IdDn : number
        Sophieu : string
        Ngaynhap : string
        Nguoitao : number
        TenNguoitao: string
        Ngaytao : string
        Nguoisua : number
        Ngaysua : string
        Tinhtrang: string
        TenTinhTrang: string
        Type: boolean
        Ghichu: string
        Nguoiduyet: number
        TenNguoiduyet: string
        Ngayduyet: string
        Lydokhongduyet: string
        attachmentId: number
        BoPhanDeNghi: number
        TenBoPhanDeNghi: string
        Lydonhap: string
        isQCKiemTra: boolean
        canCancel: boolean
        listChiTietNhapKho: DeNghiNhapKhoChiTiet[]
        FileImport: DSFileImport
        PhongBanNhap: number
        TenPhongBanNhap:string
        BoPhanNhap: number;
        KhuVucSanXuat_Id: number;
        QTSX_GiaiDoan_Id: number;
        LoaiPhieu: number;
        TenLoaiPhieu: string;
        TenBoPhanNhap:string;
        TenKhuVucSX: string;
        TenGiaiDoan: string;
        IsEnable_Duyet: boolean
        IsVisible_Duyet: boolean
        IsEnable_Sua: boolean
        numDetail: number;
        numApprove: number;
        numNotApprove: number;
        numDong: number;
        isCreateQT: boolean;
        LyDo: string
        LyDoCode: string;
        LoaiPhieuIn : string;
        ChungTuKemTheo: boolean
        SoChungTu: string
        IdKh: number
        MaKhachHang: string
        TenKhachHang: string
        clear() {
            this.IdDn = 0;
            this.Sophieu = '';
            this.Ngaynhap = '';
            this.Nguoitao = 0;
            this.TenNguoitao = '';
            this.Ngaytao = '';
            this.Nguoisua = 0;
            this.Ngaysua = '';
            this.Tinhtrang = '';
            this.TenTinhTrang = '';
            this.Type = true;
            this.Ghichu= '';
            this.Nguoiduyet= 0;
            this.TenNguoiduyet = '';
            this.Ngayduyet = '';
            this.Lydokhongduyet = '';
            this.attachmentId = 0;
            this.BoPhanDeNghi = 0;
            this.TenBoPhanDeNghi = '';
            this.Lydonhap = '';
            this.isQCKiemTra = false;
            this.canCancel = false;
            this.listChiTietNhapKho = [];
            this.IsEnable_Duyet = false;
            this.IsVisible_Duyet = false;
            this.IsEnable_Sua = false;
            this.BoPhanNhap = 0;
            this.KhuVucSanXuat_Id = 0;
            this.QTSX_GiaiDoan_Id = 0;
            this.LoaiPhieu = 0;
            this.TenLoaiPhieu = '';
            this.TenBoPhanNhap = '';
            this.TenKhuVucSX = '';
            this.TenGiaiDoan = '';
            this.numDetail = 0;
            this.numApprove = 0;
            this.numNotApprove  = 0;
            this.numDong = 0;
            this.isCreateQT = true;
            this.LyDo = ''
            this.LyDoCode = ''
            this.LoaiPhieuIn = '';
            this.SoChungTu = '';
            this.ChungTuKemTheo = false;
            this.IdKh = null
            this.MaKhachHang = ''
            this.TenKhachHang = ''
            this.PhongBanNhap = null;
            this.TenPhongBanNhap = ''
        }
        copy(item:DeNghiNhapKho){
            this.IdDn = item.IdDn;
            this.Sophieu = item.Sophieu;
            this.Ngaynhap = item.Ngaynhap;
            this.Nguoitao = item.Nguoitao;
            this.TenNguoitao = item.TenNguoitao;
            this.Ngaytao = item.Ngaytao;
            this.Nguoisua = item.Nguoisua;
            this.Ngaysua = item.Ngaysua;
            this.Tinhtrang = item.Tinhtrang;
            this.TenTinhTrang = item.TenTinhTrang;
            this.Type = item.Type;
            this.Ghichu= item.Ghichu;
            this.Nguoiduyet= item.Nguoiduyet;
            this.TenNguoiduyet = item.TenNguoiduyet;
            this.Ngayduyet = item.Ngayduyet;
            this.Lydokhongduyet = item.Lydokhongduyet;
            this.attachmentId = item.attachmentId;
            this.BoPhanDeNghi = item.BoPhanDeNghi;
            this.TenBoPhanDeNghi = item.TenBoPhanDeNghi;
            this.Lydonhap = item.Lydonhap;
            this.listChiTietNhapKho = item.listChiTietNhapKho;
            this.isQCKiemTra = item.isQCKiemTra
            this.canCancel = item.canCancel
            this.IsEnable_Duyet =  item.IsEnable_Duyet;
            this.IsVisible_Duyet =  item.IsVisible_Duyet;
            this.BoPhanNhap = item.BoPhanNhap;
            this.KhuVucSanXuat_Id = item.KhuVucSanXuat_Id;
            this.QTSX_GiaiDoan_Id = item.QTSX_GiaiDoan_Id;
            this.LoaiPhieu = item.LoaiPhieu;
            this.TenLoaiPhieu = item.TenLoaiPhieu;
            this.TenBoPhanNhap = item.TenBoPhanNhap;
            this.TenKhuVucSX = item.TenKhuVucSX;
            this.TenGiaiDoan = item.TenGiaiDoan;
            this.numDetail = item.numDetail;
            this.numApprove = item.numApprove;
            this.numNotApprove = item.numNotApprove;
            this.numDong = item.numDong;
            this.isCreateQT = item.isCreateQT
            this.LyDo = item.LyDo;
            this.LyDoCode = item.LyDoCode;
            this.LoaiPhieuIn = item.LoaiPhieuIn;
            this.SoChungTu = item.SoChungTu;
            this.ChungTuKemTheo = item.ChungTuKemTheo;
            this.IsEnable_Sua = item.IsEnable_Sua;
            this.IdKh = item.IdKh;
            this.MaKhachHang = item.MaKhachHang;
            this.TenKhachHang = item.TenKhachHang;
            this.PhongBanNhap = item.PhongBanNhap;
            this.TenPhongBanNhap = item.TenPhongBanNhap
        }
    }
    export class DeNghiNhapKhoChiTiet extends BaseModel {

        IdCtdn: number
        IdDn: number
        SoPhieuDN: string
        NgayLapPhieuDN: string
        IdHh: number
        IdPO: number
        IdKho: number
        MaPO: string
        TenHH: string
        MaHH: string
        QuyCach: string
        Dvt: number
        TenDVT: string
        Soluongkehoach: string
        Soluongchungtu: string
        Solo: string
        Sophieukiemtracl: string
        Nguoikiemtra: number
        TenNguoiKiemTra: string
        Ngaykiemtra: string
        Quyetdinhlohang: number
        Nguoinhanhang:  number
        TenNguoiNhanHang: string
        IdNcc: number
        TenNCC: string
        MaNCC: string
        Tinhtrang: boolean
        Ghichulohang: string
        IdCtyc: number
        Handung: string
        IdTs: number
        Sopo: string
        IdLo: number
        PbkiemTraId: number
        TenPBKiemTra: string
        IdNguon: number
        NguonPhatSinh: string
        GhiChuKetQuaKiemTra: string
        DaLapPhieuNhapKho: boolean
        SoMay: string
        NgaySanXat: string
        NgayDongThung: string
        NgayNhanHang: string
        SoLuongThucNhap: string
        SoLuongPhuHop: string
        SoLuongKhongPhuHop: string
        QuyetDinhTra: number
        KetQuaDuyet: number
        LyDo: string
        GhiChuTraHang: string
        TrangThaiPassHang: string
        PhuHop: boolean
        KhongPhuHop: boolean
        //Extends
        SoPhieuDH: string;
        IdPhieuDH: number;
        IdDHCT: number;
        isError: boolean
        messageError: string
        isAllComplete: boolean
        IsEnable_Duyet: boolean
        IsVisible_Duyet: boolean
        isDone: boolean
        KD_DatHang_Ct_Id: number
        DvtQuyDoi: number
        TenDvtQuyDoi: string
        KhoiLuongQuyDoi: number
        TenDvtQuyDoiNK: string
        listDVTInfo: any[]
        ExpiryDate: string
        TagInfo: string[]
        KhoiLuongGoc: number
        PalletText: string
        SoXeSoMe: string
        SoPOKH: string
        SoPONCC: string
        LenhSX: string
        MaThung: string
        isUpdated: boolean
        isDisableHH : boolean
        XacThucPallet: string
        DvtCopy: number
        IdCtNk: number
        IdCtDth:number
        IdDth:number
        DoiTuongTHCP: number
        TenDoiTuongTHCP: string
        clear() {
            this.IdCtdn = 0;
            this.IdDn= 0;
            this.SoPhieuDN= '';
            this.NgayLapPhieuDN= '';
            this.IdHh= 0;
            this.IdPO = 0;
            this.IdKho = 0;
            this.MaPO = ''
            this.TenHH = '';
            this.MaHH = '';
            this.QuyCach = '';
            this.Dvt= 0;
            this.TenDVT = '';
            this.Soluongkehoach= DeNghiNhapKho.DEFAULT_NUMBER_VALUE_NUMBER;
            this.Soluongchungtu= DeNghiNhapKho.DEFAULT_NUMBER_VALUE_NUMBER;
            this.Solo = '';
            this.Sophieukiemtracl = '';
            this.Nguoikiemtra= 0;
            this.TenNguoiKiemTra = '';
            this.Ngaykiemtra = '';
            this.Quyetdinhlohang= -1;
            this.Nguoinhanhang= 0;
            this.TenNguoiNhanHang = '';
            this.IdNcc= 0;
            this.TenNCC = '';
            this.MaNCC = '';
            this.Tinhtrang = false;
            this.Ghichulohang = '';
            this.IdCtyc= 0;
            this.Handung = '';
            this.IdTs= 0;
            this.Sopo = '';
            this.IdLo = 0;
            this.PbkiemTraId = 0;
            this.TenPBKiemTra = '';
            this.IdNguon= 0;
            this.NguonPhatSinh= '';
            this.GhiChuKetQuaKiemTra= '';
            this.SoPhieuDH = '';
            this.IdPhieuDH = 0;
            this.IdDHCT = 0;
            this.DaLapPhieuNhapKho = false;
            this.isError = false;
            this.messageError = '';
            this.isAllComplete = false;
            this.SoMay= '';   
            this.NgaySanXat= '';   
            this.NgayDongThung = ''
            this.SoLuongThucNhap = DeNghiNhapKho.DEFAULT_NUMBER_VALUE_NUMBER;
            this.SoLuongPhuHop = '';
            this.QuyetDinhTra = -1;
            this.KetQuaDuyet = -1;
            this.LyDo= '';
            this.GhiChuTraHang= '';
            this.NgayNhanHang = '';
            this.TrangThaiPassHang= '';
            this.PhuHop = false;
            this.KhongPhuHop = false;
            this.IsEnable_Duyet = false;
            this.IsVisible_Duyet = false;
            this.isDone = false;
            this.KD_DatHang_Ct_Id = 0;
            this.DvtQuyDoi = 0;
            this.TenDvtQuyDoi = '';
            this.KhoiLuongQuyDoi = 0;
            this.listDVTInfo = [];
            this.TenDvtQuyDoiNK = '';
            this.ExpiryDate = '';
            this.TagInfo = [];
            this.KhoiLuongGoc = 0;
            this.PalletText = '';
            this.SoXeSoMe = '';
            this.SoPOKH = '';
            this.SoPONCC = '';
            this.LenhSX = '';
            this.MaThung = '';
            this.isUpdated = false;
            this.isDisableHH = false;
            this.XacThucPallet = ''
            this.DvtCopy = null
            this.IdCtNk = null
            this.IdCtDth = null
            this.IdDth = null
            this.DoiTuongTHCP = null    ;
            this.TenDoiTuongTHCP = '';
        }
        copy(item:DeNghiNhapKhoChiTiet){
            this.IdCtdn = item.IdCtdn;
            this.IdDn= item.IdDn;
            this.SoPhieuDN= item.SoPhieuDN;
            this.NgayLapPhieuDN= item.NgayLapPhieuDN;
            this.IdHh= item.IdHh;
            this.IdPO = item.IdPO;
            this.IdKho = item.IdKho;
            this.MaPO = item.MaPO;
            this.TenHH = item.TenHH;
            this.MaHH = item.MaHH;
            this.QuyCach = item.QuyCach;
            this.Dvt= item.Dvt;
            this.TenDVT = item.TenDVT;
            this.Soluongkehoach= item.Soluongkehoach;
            this.Soluongchungtu= item.Soluongchungtu;
            this.Solo = item.Solo;
            this.Sophieukiemtracl = item.Sophieukiemtracl;
            this.Nguoikiemtra= item.Nguoikiemtra;
            this.TenNguoiKiemTra = item.TenNguoiKiemTra;
            this.Ngaykiemtra = item.Ngaykiemtra;
            this.Quyetdinhlohang= item.Quyetdinhlohang;
            this.Nguoinhanhang= item.Nguoinhanhang;
            this.TenNguoiNhanHang = item.TenNguoiNhanHang;
            this.IdNcc= item.IdNcc;
            this.TenNCC = item.TenNCC;
            this.MaNCC = item.MaNCC;
            this.Tinhtrang = item.Tinhtrang;
            this.Ghichulohang = item.Ghichulohang;
            this.IdCtyc= item.IdCtyc;
            this.Handung = item.Handung;
            this.NgayNhanHang = item.NgayNhanHang;
            this.IdTs= item.IdTs;
            this.Sopo = item.Sopo;
            this.IdLo = item.IdLo;
            this.PbkiemTraId = item.PbkiemTraId;
            this.TenPBKiemTra = item.TenPBKiemTra;
            this.IdNguon= item.IdNguon;
            this.NguonPhatSinh= item.NguonPhatSinh;
            this.GhiChuKetQuaKiemTra= item.GhiChuKetQuaKiemTra;
            this.SoPhieuDH = item.SoPhieuDH;
            this.IdPhieuDH = item.IdPhieuDH;
            this.IdDHCT = item.IdDHCT;
            this.DaLapPhieuNhapKho = item.DaLapPhieuNhapKho
            this.isError = item.isError;
            this.messageError = item.messageError;
            this.isAllComplete = item.isAllComplete;
            this.SoMay= item.SoMay;
            this.NgaySanXat= item.NgaySanXat; 
            this.NgayDongThung = item.NgayDongThung
            this.SoLuongThucNhap = item.SoLuongThucNhap; 
            this.SoLuongPhuHop = item.SoLuongPhuHop; 
            this.QuyetDinhTra =item.QuyetDinhTra; 
            this.KetQuaDuyet = item.KetQuaDuyet; 
            this.LyDo= item.LyDo;  
            this.GhiChuTraHang= item.GhiChuTraHang; 
            this.TrangThaiPassHang= item.TrangThaiPassHang; 
            this.PhuHop = item.PhuHop; 
            this.KhongPhuHop = item.KhongPhuHop;
            this.IsEnable_Duyet = item.IsEnable_Duyet;
            this.IsVisible_Duyet = item.IsVisible_Duyet;
            this.isDone = item.isDone;
            this.KD_DatHang_Ct_Id = item.KD_DatHang_Ct_Id;
            this.DvtQuyDoi = item.DvtQuyDoi;
            this.TenDvtQuyDoi = item.TenDvtQuyDoi;
            this.KhoiLuongQuyDoi = item.KhoiLuongQuyDoi;
            this.listDVTInfo = item.listDVTInfo;
            this.TenDvtQuyDoiNK = item.TenDvtQuyDoiNK;
            this.ExpiryDate = item.ExpiryDate;
            this.TagInfo = [];
            this.KhoiLuongGoc = item.KhoiLuongGoc;
            if(item.TagInfo && item.TagInfo.length > 0){
                item.TagInfo.forEach(el => this.TagInfo.push(el))
            }
            this.PalletText = item.PalletText;
            this.SoXeSoMe = item.SoXeSoMe;
            this.SoPOKH = item.SoPOKH;
            this.SoPONCC = item.SoPONCC
            this.LenhSX = item.LenhSX;
            this.MaThung = item.MaThung;
            this.isUpdated = item.isUpdated;
            this.isDisableHH = item.isDisableHH;
            this.XacThucPallet = item.XacThucPallet;
            this.DvtCopy = item.DvtCopy;
            this.IdCtNk = item.IdCtNk;
            this.IdCtDth = item.IdCtDth;
            this.IdDth = item.IdDth;
            this.DoiTuongTHCP = item.DoiTuongTHCP;
            this.TenDoiTuongTHCP = item.TenDoiTuongTHCP;
        }
    }
    export class DSFileImport extends BaseModel{
        listImport: FileImport[];

        clear(){
            this.listImport = [];
        }
    }
    export class FileImport extends BaseModel{
        idLoaiHH: number;
        base64: string;
        fileByte: any;
        filename: string;
        dienGiai: string;
        extension: string;

        clear(){
            this.idLoaiHH = 0;
            this.base64= '';
            this.fileByte= null;
            this.filename= '';
            this.dienGiai= '';
            this.extension= '';
        }

        copy(item: FileImport){
            this.idLoaiHH = item.idLoaiHH;
            this.base64= item.base64;
            this.fileByte= item.fileByte;
            this.filename= item.filename;
            this.dienGiai= item.dienGiai;
            this.extension= item.extension;
        }
    }
